export default __webpack_public_path__ + "static/media/Icons_Water Icon.c25ce36d.svg";